const getDiagnosisCode = ({ patient, diagnosis, value, index, showDescription = false }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedDiagnosis = diagnosis || patient.Diagnosis;
  if (index !== undefined) {
    return selectedDiagnosis[index]
      ? (showDescription ? `${selectedDiagnosis[index]['DX Code']} ${selectedDiagnosis[index]['Long Description']}` : selectedDiagnosis[index]['DX Code']) : null;
  }
  return selectedDiagnosis.map(item => (showDescription
    ? `${item['DX Code']} ${item['Long Description']}`
    : item['DX Code'])).join(showDescription ? '\n' : ', ');
};

export default getDiagnosisCode;



// WEBPACK FOOTER //
// ./src/utils/print/getDiagnosisCode.js